export enum LinkAccountErrors {
  INVALID_EMAIL = 'Invalid email',
  EMPTY = 'Empty',
  NO_ACCOUNT_FOUND = 'No account found for this email. Please verify or contact support.',
  GENERIC_ACCOUNT_LINK_ERROR = 'Unable to link accounts',
  ACCOUNT_ALREADY_LINKED = 'The account you are trying to link is already linked to another account',
}
